<template>
  <div>
    <v-expansion-panels multiple>
      <v-expansion-panel v-for="(article, index) in articles">

        <v-expansion-panel-title>
          <span class="number">{{ index + 1 }}</span>
          <span>{{ article.headline }}</span>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <!-- this div will contain html -->
          <div v-html="article.content"></div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'VServicesArticles',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    articles () {
      return this.value
    }
  }
}
</script>
